import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
	errorModal?: NzModalRef;
	errorMessage: string = '';

	constructor(
		private zone: NgZone,
		private modal: NzModalService,
		private router: Router
	) {}

	handleError(error: any): void {
		// Check if it's an error from an HTTP response
		if (!(error instanceof HttpErrorResponse)) {
			error = error.rejection; // get the error object
		}

		if (!error) {
			return;
		}

		if (error.status === 429) {
			this.errorMessage = 'You have made too many requests recently. Please wait and try again later.';
			this.zone.run(
				() =>
					(this.errorModal = this.modal.error({
						nzTitle: this.errorMessage,
					}))
			);
		}
		if (error.status === 401) {
			this.router.navigate(['/auth']);
		}
	}
}
